import {useAuth} from '@app/modules/auth'

const useIsPremium = () => {
  const isPremium = useAuth().currentUser?.is_premium

  return isPremium
}

export default useIsPremium
